<template>
    <div class="bonusomat-spin-buttons">
        <DsButton
            class="bonusomat-spin-button__spin"
            @click="spinClickInternal"
            v-show="!showCloseButton"
            size="lg"
            :is-disabled="isPrimaryButtonDisabled"
            icon-right="b-mat"
            is-block
        >
            Zatočit bonusomatem
        </DsButton>

        <DsButton
            class="bonusomat-spin-button__close"
            :class="{ 'bonusomat-spin-button__close--allwyn': allwynPageUrl }"
            @click="closeClickInternal"
            :href="allwynPageUrl"
            :eventName="allwynPageUrl ? 'openLinkBrowser' : null"
            :event-argument="allwynPageUrl ? allwynPageUrl : null"
            v-show="showCloseButton"
            size="lg"
            type="interaction"
            theme="dark"
            :icon-right="closeBtnIcon"
            :open-in-new-tab="true"
            is-block
        >
            {{ closeBtnText }}
        </DsButton>

        <TransitionFade>
            <div class="bonusomat-spin-button__tooltip" v-show="showTooltip">
                <WebpImage
                    class="bonusomat-spin-button__tooltip-caret"
                    :src="caretSrc"
                    alt=""
                    :width="24"
                    :height="8"
                />
                Zatočit Bonusomatem si můžete vždy pouze 1 x denně.
            </div>
        </TransitionFade>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { SpinAutomatState } from "../../../models/bonusomat-spin-types";
import { bonImgUrl } from "../../../utils/image-src";

const emit = defineEmits(["spinClick", "closeModal"]);

const props = defineProps<{
    state: SpinAutomatState;
    allwynPageUrl?: string;
}>();

const isPrimaryButtonDisabled = computed(() => props.state != "ACTIVE");
const showCloseButton = computed(() => props.state == "EMPTY" || props.state == "WINNING");
const showTooltip = computed(() => props.state == "DISABLED");
const caretSrc = computed(() => bonImgUrl("tooltip-caret", "svg"));
const closeBtnIcon = computed(() => (props.allwynPageUrl ? "arrow-right" : "cross"));
const closeBtnText = computed(() => (props.allwynPageUrl ? "Více o zážitku" : "Zavřít Bonusomat"));

const spinClickInternal = () => emit("spinClick");
const closeClickInternal = () => !props.allwynPageUrl && emit("closeModal");
</script>
